export const STRENGTH_CONTENTS = {
    title: 'Top Strengths',
    className: "strength-category"
}

export const DEVELOPMENT_CONTENTS = {
    title: "Top Areas for  Growth",
    className: "development-category "
}